<template>
  <div id="app" style="height: 100%">
    <NavBar />
    <b-container class="mt-2" fluid style="height: 100%">
      <MarketInfo />
      <Traders class="" />
    </b-container>
    <SaveManager />
    <FeedbackForm />
    <OnboardingTour />
  </div>
</template>

<script>
import MarketInfo from './components/MarketInfo.vue'
import Traders from './components/Traders.vue'
import NavBar from './components/NavBar'
import SaveManager from './components/SaveManager.vue'
import FeedbackForm from './components/FeedbackForm.vue'
import OnboardingTour from './components/OnboardingTour.vue'

export default {
  name: 'App',
  components: {
    MarketInfo,
    Traders,
    NavBar,
    SaveManager,
    FeedbackForm,
    OnboardingTour
  },
  mounted: function () {
    this.$nextTick(function() {
    window.addEventListener('resize', this.getDim)
    this.getDim()
    })
  },
  data() {
    return {
      layoutOption: 1
    }
  },
  methods: {
    getDim () {
      let height = document.documentElement.clientHeight;
      this.$store.commit( 'setHeight', height)
    }
  }
}
</script>

<style>
  * {
    scrollbar-width: thin;
    scrollbar-color: grey whitesmoke;
  }

  /* Works on Chrome/Edge/Safari */
  *::-webkit-scrollbar {
    width: 7px;
  }

  *::-webkit-scrollbar-track {
    background: whitesmoke;
  }

  *::-webkit-scrollbar-thumb {
    background-color: grey;;
    border-radius: 20px;
    border: 2px solid grey;
  }
  html {
    font-size: 0.8rem;
    height: 100%;
  }
  body {
    background-color: #343a40 !important;
    height: 100%;
  }
  /* @media screen and (min-height: px) and (orientation: landscape) {
    body {
      background-color: lightgreen !important;
    }
  }*/
</style>
